module.exports = __webpack_public_path__ + "img/2018-1.22fec250.jpg";